const languages = [
    {
        name: 'Svelte',
        asset: '<svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="30" height="30"><path d="M9.625 8.357l-5.088 3.18m2.968-1.855a3.5 3.5 0 01-3.71-5.937l4.241-2.65A3.5 3.5 0 0112.405 6.5M7.536 5.296a3.5 3.5 0 013.71 5.936l-4.24 2.65A3.5 3.5 0 012.614 8.5m2.8-1.88l5.09-3.179" stroke="currentColor"></path></svg>',
        position: [

        ]
    },
    {
        name: 'Javascript',
        asset: '<svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="30" height="30"><path d="M12.5 8v-.167c0-.736-.597-1.333-1.333-1.333H10a1.5 1.5 0 100 3h1a1.5 1.5 0 010 3h-1A1.5 1.5 0 018.5 11m-2-5v5a1.5 1.5 0 01-3 0M.5.5h14v14H.5V.5z" stroke="currentColor"></path></svg>',
        position: [

        ]
    },
    {
        name: 'Node',
        asset: '<svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="30" height="30"><path d="M11.5 6v-.167c0-.736-.597-1.333-1.333-1.333H9a1.5 1.5 0 100 3h1a1.5 1.5 0 010 3H9A1.5 1.5 0 017.5 9m-2-5v5.264a2 2 0 01-1.106 1.789L3.5 11.5m-2-1v-6l6-3.5 6 3.5v6l-6 3.5-6-3.5z" stroke="currentColor"></path></svg>',
        position: [

        ]
    },
    {
        name: 'React',
        asset: '<svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="30" height="30"><path d="M14.5 7.584c0 1.657-3.134 3-7 3s-7-1.343-7-3 3.134-3 7-3 7 1.343 7 3z" stroke="currentColor"></path><path d="M4.166 13.739c1.457.79 4.13-1.327 5.972-4.726 1.841-3.4 2.153-6.795.696-7.584-1.457-.79-4.13 1.327-5.972 4.726-1.841 3.4-2.153 6.795-.696 7.584z" stroke="currentColor"></path><path d="M10.834 13.739c-1.457.79-4.13-1.327-5.972-4.726-1.841-3.4-2.153-6.795-.696-7.584 1.457-.79 4.13 1.327 5.972 4.726 1.841 3.4 2.153 6.795.696 7.584z" stroke="currentColor"></path><path d="M6.5 7.584a1 1 0 102 0 1 1 0 00-2 0z" stroke="currentColor"></path></svg>',
        position: [

        ]
    },
    {
        name: 'CSS',
        asset: '<svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="30" height="30"><path d="M5 3.5h6.5v3M7 6.5h4.5m0 0v3l-3 1-3-1V8M1.5.5h14l-1 12-6 2-6-2-1-12z" stroke="currentColor"></path></svg>',
        position: [

        ]
    },
    {
        name: 'HTML5',
        asset: '<svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="30" height="30"><path d="M12 3.5H5.5v3h6v3l-3 1-3-1V8M1.5.5h14l-1 12-6 2-6-2-1-12z" stroke="currentColor"></path></svg>',
        position: [

        ]
    },
    {
        name: 'Rust',
        asset: '<svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="30" height="30"><path d="M2 10.5h5m-4.5-6H9a1.5 1.5 0 110 3H4.5m0-3v6m3-3h1a2 2 0 012 2 1 1 0 001 1H13M7.5.5l1.344 1.11 1.693-.417.73 1.584 1.706.359-.03 1.743 1.382 1.063L13.54 7.5l.784 1.558-1.382 1.063.03 1.743-1.707.359-.729 1.584-1.693-.418L7.5 14.5l-1.344-1.11-1.693.417-.73-1.584-1.706-.359.03-1.743L.675 9.058 1.46 7.5.675 5.942 2.057 4.88l-.03-1.743 1.706-.359.73-1.584 1.693.417L7.5.5z" stroke="currentColor" stroke-linejoin="round"></path></svg>',
        position: [

        ]
    },
    {
        name: 'Linux',
        asset: '<svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="30" height="30"><path d="M.5 14.5l-.354-.354A.5.5 0 00.5 15v-.5zm.656-.656l-.353-.354.353.354zM14.5 14.5v.5a.5.5 0 00.354-.854l-.354.354zm-11-4l-.224-.447a.5.5 0 00-.13.8L3.5 10.5zm.87-.435l.223.447-.223-.447zm6.26 0l-.223.447.223-.447zm.87.435l.354.354a.5.5 0 00-.13-.801l-.224.447zm-7.414.586l.353-.354-.353.354zM.854 14.854l.656-.657-.707-.707-.657.656.708.708zM2 13.014V6.5H1v6.514h1zM13 6.5v6.514h1V6.5h-1zm.49 7.697l.656.657.708-.708-.657-.656-.707.707zM14.5 14H.5v1h14v-1zm-1.5-.986c0 .444.176.87.49 1.183l.707-.707a.673.673 0 01-.197-.476h-1zM7.5 1A5.5 5.5 0 0113 6.5h1A6.5 6.5 0 007.5 0v1zM2 6.5A5.5 5.5 0 017.5 1V0A6.5 6.5 0 001 6.5h1zm-.49 7.697c.314-.314.49-.74.49-1.183H1c0 .179-.07.35-.197.476l.707.707zm2.214-3.25l.87-.434-.448-.895-.87.435.448.894zm6.683-.434l.87.434.447-.894-.87-.435-.447.894zm.74-.367l-.586.586.707.707.586-.585-.708-.708zm-6.708.586l-.585-.586-.708.708.586.585.707-.707zM7.5 12a4.328 4.328 0 01-3.06-1.268l-.708.707c1 1 2.355 1.561 3.768 1.561v-1zm3.06-1.268A4.328 4.328 0 017.5 12v1a5.328 5.328 0 003.768-1.56l-.707-.708zm-5.967-.22a6.5 6.5 0 015.814 0l.447-.894a7.5 7.5 0 00-6.708 0l.447.894zM7 6.5v1h1v-1H7zm-3 1v-1H3v1h1zM5.5 9A1.5 1.5 0 014 7.5H3A2.5 2.5 0 005.5 10V9zM7 7.5A1.5 1.5 0 015.5 9v1A2.5 2.5 0 008 7.5H7zM5.5 5A1.5 1.5 0 017 6.5h1A2.5 2.5 0 005.5 4v1zm0-1A2.5 2.5 0 003 6.5h1A1.5 1.5 0 015.5 5V4zM11 6.5v1h1v-1h-1zM9.5 9A1.5 1.5 0 018 7.5H7A2.5 2.5 0 009.5 10V9zM11 7.5A1.5 1.5 0 019.5 9v1A2.5 2.5 0 0012 7.5h-1zM9.5 5A1.5 1.5 0 0111 6.5h1A2.5 2.5 0 009.5 4v1zm0-1A2.5 2.5 0 007 6.5h1A1.5 1.5 0 019.5 5V4zM5 7v1h1V7H5zm4 0v1h1V7H9z" fill="currentColor"></path></svg>',
        position: [

        ]
    },
    // {
    //     name: 'Svelte',
    //     asset: '',
    //     position: [

    //     ]
    // },
]

export default languages